import { Box } from "@jewlr/storybook/core"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { SectionTitle, Section, Text } from "@jewlr/storybook/info"

const InfoLink = styled(Link).attrs((props) => ({
  mb: 1,
  ...props,
}))`
  && {
    color: ${(props) => props.theme.colors.black};
    font-size: 18px;
    font-weight: 300;
    text-decoration: underline;
  }
`

const Covid = () => (
  <Box mb={7}>
    <Box contain>
      <Section>
        <Text>
          At Jewlr, we are committed to the health and safety of our staff and
          community. We continue to fulfill orders with the same care and
          quality our customers expect from us. To play our part in reducing the
          spread of COVID-19 and keep our employees and their families safe, we
          have put in the appropriate precautions and redesigned our processes.
        </Text>
        <Text>
          We also believe we need to give back to our community throughout a
          time of crisis. During the PPE shortage, we were able to donate our
          inventory of N95 masks to local hospitals, and we produced face
          shields for frontline workers. We will continue to look for ways in
          which we can use our platform to support our communities.
        </Text>
        <Text>Stay healthy & never lose your sparkle ✨.</Text>
        <Text>Sincerely</Text>
        <Text>
          Daniel Stoppel <br /> CEO
        </Text>
      </Section>
    </Box>
    <Section hasBg mb="0px" py="40px" textAlign="center">
      <SectionTitle mb={4}>USEFUL LINKS</SectionTitle>
      <Text>
        <InfoLink data-lc="covid" to="/info/returns">
          Return Policy
        </InfoLink>
      </Text>
      <Text>
        <InfoLink data-lc="covid" to="/order/return">
          Returns
        </InfoLink>
      </Text>
      <Text>
        <InfoLink data-lc="covid" to="/order/repair">
          Repairs
        </InfoLink>
      </Text>
      <Text>
        <InfoLink data-lc="covid" to="/order/resizing">
          Resizing
        </InfoLink>
      </Text>
    </Section>
  </Box>
)

Covid.propTypes = {}

export default Covid
